// Port of src/user/modules/info_elements/context_warning_info.jsx (mounted from header.jsx via
// `showContextWarning`).
//
// The trigger is NOT the `isAdmin` permission flag — it is membership of the internal admin client.
// Staff accounts have the platform's own client in their `/ui/clients` list; when they switch the
// header's client selector to a customer, every action they take (a withdrawal, a payout, an API
// key) lands on that customer's account, so the shell shows a standing warning.
//
// Two ids are exempt: the admin client itself (acting on it is acting on your own account) and one
// further internal client, both hard-coded in the React source and carried over verbatim rather
// than guessed — they identify specific rows in the production `clients` table.
export const ADMIN_CLIENT_ID = "00000000-0000-0000-0000-000000000000";
const SECOND_INTERNAL_CLIENT_ID = "e27a2a60-dfa8-4f71-aa9c-41c25be27efb";
export const OWN_ACCOUNT_CLIENT_IDS = [ADMIN_CLIENT_ID, SECOND_INTERNAL_CLIENT_ID];

// `clientIds` are the ids of every client the signed-in user can act as; `activeId` the one the
// header currently has selected.
export const isImpersonatingClient = (clientIds, activeId) =>
  Boolean(activeId) &&
  (clientIds ?? []).includes(ADMIN_CLIENT_ID) &&
  !OWN_ACCOUNT_CLIENT_IDS.includes(activeId);
